import {Button, Container, Grid, Typography} from '@material-ui/core';
import {DatePicker} from '@material-ui/pickers';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {openMsg, loadingModal} from 'redux-app';
import {columns, filtrosIniciales, options} from './config';
import SearchIcon from '@material-ui/icons/Search';
import MUIDataTable from 'mui-datatables';
import gql from 'graphql-tag';
import {useLazyQuery} from '@apollo/react-hooks';
import { useStyles } from './styles';

const reporteAsesorCliente = gql`
   query data($cliente: String!, $fechaInicio: Date, $fechaFin: Date) {
      atencionClienteIntranet(cliente: $cliente, fechaInicio: $fechaInicio, fechaFin: $fechaFin) {
         codigo
         producto
         nroAct
         nroSop
         nroCap
         nroIns
         nroAteIni
         nroAtePro
         nroAteFin
         nroAteCan
      }
   }
`;

function formatGraphQLDate(date) {
   if (date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);

      return `${year}-${month}-${day}`;
   }
   return date;
}

function ReporteAtencion({usuario, openMsgModal, openWaitModal}) {
    const classes = useStyles();
   const [filtros, setFiltros] = useState(filtrosIniciales);

   const [dataTable, setDataTable] = useState([]);

   const handleChangeFiltros = (elegido, propiedad) => {
      setFiltros(() => {
         return {...filtros, [propiedad]: elegido};
      });
   };

   const [getReporteAtencionCliente, {data, error, loading}] = useLazyQuery(reporteAsesorCliente);

   useEffect(() => {
      handleChangeFiltros(usuario.codigo, 'cliente');
   }, [usuario]);

   useEffect(() => {
      if (error) {
         openMsgModal(JSON.stringify(error));
      }
   }, [error]);

   useEffect(() => {
      openWaitModal(loading);
   }, [loading]);

   useEffect(() => {
      if (data) {
         setDataTable(data.atencionClienteIntranet);
      }
   }, [data]);

   const handleGetData = () => {
      getReporteAtencionCliente({
         variables: {
            cliente: filtros.cliente,
            fechaInicio: formatGraphQLDate(filtros.fechaInicio),
            fechaFin: formatGraphQLDate(filtros.fechaFin)
         }
      });
   };

   useEffect(() => {
      if (filtros.cliente) {
         handleGetData();
      }
   }, [filtros.cliente]);

   return (
      <Container className="containerBox" style={{maxWidth: '95%'}}>
         <Grid container spacing={3}>
            <Grid item xs={12}>
               <Typography variant="h2" gutterBottom>
                  Reporte de Atención
               </Typography>
            </Grid>
            <Grid container item spacing={1}>
               <Grid item xs={3}>
                  <DatePicker
                     name="fechaInicial"
                     label="Fecha Inicial"
                     value={filtros.fechaInicio}
                     onChange={date => {
                        handleChangeFiltros(date, 'fechaInicio');
                     }}
                     inputVariant="outlined"
                     format="dd/MM/yy"
                     fullWidth
                     margin="dense"
                     autoOk
                  />
               </Grid>
               <Grid item xs={3} md={2}>
                  <DatePicker
                     name="fechaFinal"
                     label="Fecha Final"
                     value={filtros.fechaFin}
                     onChange={date => {
                        handleChangeFiltros(date, 'fechaFin');
                     }}
                     inputVariant="outlined"
                     format="dd/MM/yy"
                     fullWidth
                     margin="dense"
                     autoOk
                  />
               </Grid>
               <Grid item xs={2} style={{display: 'flex', alignItems: 'center'}}>
                  <Button
                     size="small"
                     color="primary"
                     variant="outlined"
                     endIcon={<SearchIcon />}
                     onClick={handleGetData}
                  >
                     Consultar
                  </Button>
               </Grid>
            </Grid>
            <Grid container item xs={12}>
               <MUIDataTable columns={columns} options={options} data={dataTable} 
                  className={classes.tabla}/>
            </Grid>
         </Grid>
      </Container>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openMsgModal: msg => dispatch(openMsg(msg)),
      openWaitModal: loading => dispatch(loadingModal(loading))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReporteAtencion);
